export default __webpack_public_path__ + "static/media/twitter-circle.70187f44.svg";